<div class="w-full h-full bg-neutral-100 flex flex-col xl:py-2">
    <div class="bg-tb-app-heading text-tb-app-heading-contrast shadow-xl min-h-14 max-h-14 flex flex-row px-2 items-center xl:rounded-md">
        <button mat-flat-button matRipple class="bg-tb-app-heading text-tb-app-heading-contrast min-w-10 px-0" (click)="navBack()">
            <mat-icon svgIcon="heroicons_outline:arrow-left"></mat-icon>
        </button>
        <h3 class="ml-1">{{ headerCaption() }}</h3>
    </div>
    <div class="overflow-auto p-4 max-w-3xl mx-auto w-full h-full">
        @if (errorComponent() != null){
            <ng-container
                *ngComponentOutlet="errorComponent().component; inputs: errorComponent().inputs; injector: errorComponent().injector; content: errorComponent().content"
            />
        } @else {
            <ng-content select="[pageContent]"></ng-content>
        }
    </div>
</div>
